/* eslint-disable no-console */

import * as Api from '../api/v1/student';
import { CREATE_STUDENT } from '../constants/actionTypes';

export const createStudent = (
  name,
  email,
  phone,
  dob,
  gender,
  city,
  hear_about_us,
  current_status,
  student_studying_profile,
  student_working_profile,
  student_looking_job_profile,
  student_confused_profile,
  course_level_id
) => (dispatch, start) => {
  start(CREATE_STUDENT);
  return Api.createStudent(
    name,
    email,
    phone,
    dob,
    gender,
    city,
    hear_about_us,
    current_status,
    student_studying_profile,
    student_working_profile,
    student_looking_job_profile,
    student_confused_profile,
    course_level_id
  ).then(response => response);
};



// WEBPACK FOOTER //
// ./src/actions/student.js